import React from 'react';
import styles from './_styles.less';

export default function() {
  return <div className={styles['centered']} />;
};
